module.exports = __webpack_public_path__ + "media/images/posts/brivdaba-27e1489e060d9ff3b6414b6470312c09.jpg";